export default __webpack_public_path__ + "static/media/background.1d96fd8f.svg";